import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';

import ChatIcon from '@mui/icons-material/Chat';

const contactItems = [
  {
    icon: <SupportAgentIcon color='secondary' style={{ fontSize: 70 }} />,
    title: 'Central de Atendimento Innova 24h',
    phone: '(69)2018-0099',
    description: 'Assuntos relacionados à autorização, rede credenciada, fatura, cartão, contratos e demais serviços.',
  },
  // {
  //   icon: <EventNoteIcon color='secondary' style={{ fontSize: 70 }} />,
  //   title: 'Central de Marcação de Consultas',
  //   phone: '(99)99999-9999',
  //   description: 'De 2ª a 6ª, 8h às 20h. Sáb. de 8h às 14h.',
  // },
  // {
  //   icon: <HeadsetMicIcon color='secondary' style={{ fontSize: 70 }} />,
  //   title: 'SAC – Serviço de Atendimento ao Cliente 24h',
  //   phone: '9999-999-999',
  //   description: 'Exclusivo para reclamação, cancelamento, informação e dúvida.',
  // },
  // {
  //   icon: <HearingIcon color='secondary' style={{ fontSize: 70 }} />,
  //   title: 'SAC – Deficiente Auditivo ou de Fala 24h',
  //   phone: '(24h)9999-999-999',
  //   description: 'Necessário dispositivo TDD.',
  // },
  // {
  //   icon: <ApartmentIcon color='secondary' style={{ fontSize: 70 }} />,
  //   title: 'Suporte Empresarial',
  //   phone: '9999-999-999',
  //   description: 'De 2ª a 6ª, 8h às 17:30h.',
  // },
  // {
  //   icon: <LocalHospitalIcon color='secondary' style={{ fontSize: 70 }} />,
  //   title: 'Innova Urgente',
  //   phone: '9999-999-999',
  //   description: '',
  // },
  {
    icon: <ChatIcon color='secondary' style={{ fontSize: 70 }} />,
    title: 'Ouvidoria',
    phone: '0800 345 9999',
    description: 'De 2ª a 6ª, 8h ás 17:00h, exceto feriados.',
  },
];  

const ContactSection: React.FC = () => {
  return (
    <Box p={4} textAlign="center">
      <Typography variant="h4" color="warning" gutterBottom>
        Fale com a Innova Plano de Saúde
      </Typography>
      <Typography variant="body1" color="textSecondary" mb={4}>
        Para cuidar melhor de você, queremos te ouvir. Estamos prontos para atender o seu contato.
      </Typography>

      <Grid container spacing={4} display="flex" justifyContent="center">
        {contactItems.map((item, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Box textAlign="center">
              {item.icon}
              <Typography variant="h6" fontWeight="bold" mt={2}>
                {item.title}
              </Typography>
              <Typography variant="body1" fontWeight={600} color="warning" mt={1}>
                {item.phone}
              </Typography>
              <Typography variant="body2" color="textSecondary" mt={1}>
                {item.description}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ContactSection;
